import NewPostForm from "./PostForm"

export default NewPostForm;